import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-openIcon",
  "use": "icon-openIcon-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-openIcon\"><rect x=\"3\" y=\"3\" width=\"16\" height=\"2\" /><rect x=\"3\" y=\"7\" width=\"10\" height=\"2\" /><rect x=\"3\" y=\"11\" width=\"10\" height=\"2\" /><rect x=\"3\" y=\"16\" width=\"16\" height=\"2\" /><polygon points=\"19 13 19 8 15 10.5 19 13\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol